import { render, staticRenderFns } from "./SharedRecordsPage.vue?vue&type=template&id=b94b5c5e&scoped=true"
import script from "./SharedRecordsPage.vue?vue&type=script&lang=js"
export * from "./SharedRecordsPage.vue?vue&type=script&lang=js"
import style0 from "./SharedRecordsPage.vue?vue&type=style&index=0&id=b94b5c5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94b5c5e",
  null
  
)

export default component.exports